// Lightweight canvas-less DOM confetti celebration effect

export function triggerCelebration(originX = 0.5, originY = 0.4): void {
  if (typeof document === 'undefined') return;

  const count = 50;
  const colors = ['#f59e0b', '#10b981', '#3b82f6', '#ec4899', '#8b5cf6', '#ef4444'];
  const container = document.createElement('div');
  container.className = 'pointer-events-none fixed inset-0 z-[9999] overflow-hidden';
  document.body.appendChild(container);

  const startX = window.innerWidth * originX;
  const startY = window.innerHeight * originY;

  for (let i = 0; i < count; i++) {
    const particle = document.createElement('div');
    const color = colors[Math.floor(Math.random() * colors.length)] ?? '#f59e0b';
    const size = Math.random() * 8 + 6;
    const angle = Math.random() * Math.PI * 2;
    const velocity = Math.random() * 600 + 200;
    const vx = Math.cos(angle) * velocity;
    const vy = Math.sin(angle) * velocity - 200;

    particle.style.position = 'absolute';
    particle.style.left = `${startX}px`;
    particle.style.top = `${startY}px`;
    particle.style.width = `${size}px`;
    particle.style.height = `${size * 0.6}px`;
    particle.style.backgroundColor = color;
    particle.style.borderRadius = '2px';
    particle.style.transform = `rotate(${Math.random() * 360}deg)`;
    particle.style.transition =
      'transform 2.2s cubic-bezier(0.25, 1, 0.5, 1), opacity 2.2s ease-out';
    particle.style.opacity = '1';

    container.appendChild(particle);

    requestAnimationFrame(() => {
      particle.style.transform = `translate(${vx * 0.8}px, ${vy * 0.8 + 500}px) rotate(${
        Math.random() * 1080 - 540
      }deg) scale(${Math.random() * 0.5 + 0.5})`;
      particle.style.opacity = '0';
    });
  }

  setTimeout(() => {
    container.remove();
  }, 2400);
}
